<script setup lang="ts">
import { computed, onBeforeMount, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import useEntityApi from '../../../../Composables/useEntityApi.ts'
import useUser from '../../../../Composables/User/useUser.ts'
import DocumentList from '../Document/DocumentList.vue'
import BlockContent from '../UI/Content/BlockContent.vue'
import LazyContent from '../UI/Loading/LazyContent.vue'
import PlaceholderContent from '../UI/Loading/PlaceholderContent.vue'

type DocumentListType = InstanceType<typeof DocumentList>

const props = defineProps<{
  entityId: number
}>()

const { t } = useI18n()
const { isReadOnly } = useUser()
const { fetchEntity, refreshEllisphere } = useEntityApi(props.entityId)

const entity = ref<Entity>()
const documentList = ref<DocumentListType>()

const hasEllisphere = computed<boolean>(() => !!entity.value?.scoreInfos?.ellisphere?.score)

async function loadEntity() {
  entity.value = await fetchEntity()
}

function refreshDocumentList() {
  documentList.value?.getDocuments()
}

async function updateEllisphere() {
  await refreshEllisphere()
  refreshDocumentList()
}

onBeforeMount(() => {
  loadEntity()
})
</script>

<template>
  <BlockContent color="primary" inner-bloc-class="border-contract-yellow">
    <template #header>
      <h5 class="text-primary">{{ t('simulation.document.title') }}</h5>
      <button
        v-if="hasEllisphere && !isReadOnly"
        class="btn btn-sm btn-square btn-outline btn-round btn-primary"
        style="width: max-content; height: max-content"
        @click="updateEllisphere"
      >
        <i class="fa fa-refresh"></i> {{ $t('document.generate.ellisphere') }}
      </button>
    </template>
    <LazyContent :loading="!entity">
      <DocumentList
        id="document-entity"
        ref="documentList"
        context="Entity"
        :context-id="entityId"
        without-missing
        style="max-width: 100%; overflow: auto"
        @document-uploaded="refreshDocumentList"
      />
      <template #loader>
        <div class="row mt-2">
          <PlaceholderContent :rows="5" class="col" />
        </div>
      </template>
    </LazyContent>
  </BlockContent>
</template>
